import { OfferImage } from 'components/offer/card/OfferImage';
import 'components/offer/card/OfferCard.less';
import type { ZboziPromoOfferData } from 'service/zbozi/model';
import { price, priceString } from 'utils/format';
import { cn } from 'utils/cn';
import { MoneyTag } from 'components/atoms/MoneyTag';
import { pluralize, localize } from 'i18n/localize';

const $t = localize();

export interface Props {
	lazyImage?: boolean;
	zboziOffer: ZboziPromoOfferData;
}

/**
 * For easier styling this component relies on tailwind and also on its sibling .less file for nested CSS selectors.
 */
export function ZboziPromoOfferCard({ lazyImage, zboziOffer }: Props) {
	return (
		<a class="group/card" href={zboziOffer.link}>
			<div class="offer-card @container w-full h-full relative">
				<div
					class={cn(
						'relative offer-card__image-wrapper rounded-2xl bg-background flex items-center justify-center overflow-hidden',
					)}
				>
					<OfferImage
						className="group-hover/card:scale-105 transition-all duration-500"
						images={[{ src: zboziOffer.image }]}
						imgClassName="mix-blend-multiply p-4 object-contain	aspect-square w-full h-full"
						lazy={lazyImage}
					/>
				</div>
				<div class="py-3 @cardLg:px-2 pb-0">
					<div class="text-red line-clamp-2 overflow-ellipsis leading-6">{zboziOffer.title}</div>
					<div class="mt-1 line-clamp-1 overflow-ellipsis text-dark-blue-50 flex gap-1 flex-wrap items-baseline">
						<b class="text-neutral-black flex-none">
							{priceString(zboziOffer.priceFrom, true)}&nbsp;–&nbsp;{price(zboziOffer.priceTo, true)}
						</b>
						&nbsp;
						<span class="whitespace-pre overflow-ellipsis text-dark-blue-50 group-hover/card:text-dark-blue truncate shrink">
							{pluralize(zboziOffer.shopCount, $t.zboziOffers.shopCount, true)}
						</span>
						&ndash;
						<MoneyTag className="h-[11px] md:h-3" />
					</div>
				</div>
			</div>
		</a>
	);
}
